/**
 * @file: SelectPill.tsx
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 *
 * A toggle chip: filled brand when selected, a quiet hairline surface when idle
 * — the same selected/idle contrast the log-activity channel pills use.
 */

import { Typography } from '@euler/app/components/typography';
import { LD } from '@euler/app/flows/leads/pages/detail/components/leadDetailKit';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { Check } from 'lucide-react-native';
import { TouchableOpacity } from 'react-native';

export const SelectPill = ({
  label,
  active,
  onPress,
}: {
  label: string;
  active: boolean;
  onPress: () => void;
}) => {
  const { rpx } = useResponsiveContext();
  const fg = active ? '#fff' : LD.steel;
  return (
    <TouchableOpacity
      activeOpacity={0.8}
      onPress={onPress}
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        paddingHorizontal: rpx(13),
        paddingVertical: rpx(8),
        borderRadius: rpx(10),
        backgroundColor: active ? LD.brand : LD.surface,
        borderWidth: 1,
        borderColor: active ? LD.brand : LD.hairline,
      }}
    >
      {active ? (
        <Check size={rpx(13)} color={fg} style={{ marginRight: rpx(4) }} />
      ) : null}
      <Typography.Text
        size={rpx(13)}
        color={fg}
        bold={active || undefined}
        medium={!active || undefined}
      >
        {label}
      </Typography.Text>
    </TouchableOpacity>
  );
};
